import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96",
  class: "player-2-gradient_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "url(#player-2-gradient_svg__a)",
      d: "M10.533 88.972c-3.93-.605-6.79-4.094-6.515-8.12.39-5.717 1.372-10.168 3.914-12.744 4.611-4.673 7.03-5.192 9.07-5.63.425-.092.834-.18 1.243-.3 1.343-.402 1.476-.485 1.924-.764.341-.213.867-.541 2.257-1.213 3.202-1.558 5.293-2.685 7.11-3.954l.55-.386c1.806-1.262 4.283-2.995 5.162-4.27l-.413-7.346s-2.09-4.52-2.09-5.506c0 0-1.253 1.41-2.51-.566l-.164-.257c-1.393-2.19-4.917-7.73-3.045-9.633 0 0 .839-.56 1.531 0 0 0-4.88-11.72 4.321-19.491 9.195-7.772 16.304-4.803 21.604-.142 5.293 4.662 4.46 13.838 4.46 13.838s3.901-.985 3.628 2.968a85.31 85.31 0 0 0-.085 1.442c-.216 4.033-.508 9.493-4.096 6.607 0 0 .42 4.52-.28 6.355-.698 1.835 0 11.3 0 11.3s7.25 7.624 8.922 8.9c1.67 1.274 4.74 2.542 9.62 4.52 1.07.433 2.202.806 3.337 1.18 4.039 1.33 8.133 2.677 9.764 6.868.94 2.412 1.683 5.503 2.16 8.493.618 3.878-2.082 7.274-5.9 7.904C78.505 90.261 65.124 92 49.176 92 33 92 18.585 90.212 10.532 88.972Z"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "player-2-gradient_svg__a",
        x1: "48",
        x2: "48",
        y1: "4",
        y2: "92",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          offset: "0",
          "stop-color": "#fff",
          "stop-opacity": ".5"
        }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#fff",
          "stop-opacity": ".1"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }